module.exports = __webpack_public_path__ + "static/img/file_rar.dcec96f9.png";